import * as Joi from 'joi';
export const StatementAcceptanceSchema = Joi.object({
  agreeTermsPrivacy: Joi.boolean().invalid(false).required().messages({
    'any.invalid':
      'Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy',
  }),

  businessTypeId: Joi.any(),
  merchantName: Joi.any(),
  merchantBusinessName: Joi.any(),
  businessHandle: Joi.any(),
  merchantCompanyTin: Joi.any(),

  mainOfficeContactNumber: Joi.any(),
  mainOfficeBldgNameNo: Joi.any(),
  mainOfficeStreetAddress: Joi.any(),
  mainOfficeBarangay: Joi.any(),
  mainOfficeCity: Joi.any(),
  mainOfficeProvince: Joi.any(),
  mainOfficePostalCode: Joi.any(),

  isBrickAndMortarStore: Joi.any(),
  industry: Joi.any(),
  serviceDescription: Joi.any(),
  modeOfPayment: Joi.any(),
  currency: Joi.any(),
  aubPartnerId: Joi.any(),
  estimatedMonthlyGrossTransaction: Joi.any(),

  businessWebsiteUrl: Joi.any(),
  facebookUrl: Joi.any(),
  twitterUrl: Joi.any(),
  instagramUrl: Joi.any(),
  tiktokUrl: Joi.any(),
  isBusinessWebsiteUnderDevelopment: Joi.any(),

  aFirstName: Joi.any(),
  aMiddleName: Joi.any(),
  isAMNameDisabled: Joi.any(),
  aLastName: Joi.any(),
  aPosition: Joi.any(),
  aEmailAddress: Joi.any(),
  aContactNumber: Joi.any(),
  aDateOfBirth: Joi.any(),
  aMothersMaidenName: Joi.any(),
  aGender: Joi.any(),
  aAubNationalityCode: Joi.any(),
  aAubDeviceId: Joi.any(),
  aAubIdCode: Joi.any(),
  aAubIdNumber: Joi.any(),
  aAubRegionCode: Joi.any(),

  settlements: Joi.any(),

  isWantPackworksWallet: Joi.any(),
  isWantPayMayaBankWallet: Joi.any(),
  isWantPayMayaBankAccount: Joi.any(),

  idsOfValidSignatories: Joi.any(),
  idsOfValidSignatoriesBack: Joi.any(),
  idsOfValidSignatoriesSignature: Joi.any(),

  barangayBusinessPermit: Joi.any(),
  barangayBusinessPermitBack: Joi.any(),
  barangayBusinessPermitSignature: Joi.any(),

  storePhoto: Joi.any(),

  mayorsOrBusinessPermit: Joi.any(),
  mayorsOrBusinessPermitBack: Joi.any(),
  mayorsOrBusinessPermitSignature: Joi.any(),

  birCert2303: Joi.any(),
  birCert2303Back: Joi.any(),
  birCert2303Signature: Joi.any(),

  secCert: Joi.any(),
  secCertBack: Joi.any(),
  secCertSignature: Joi.any(),

  aoiAndByLaws: Joi.any(),
  aoiAndByLawsBack: Joi.any(),
  aoiAndByLawsSignature: Joi.any(),

  gis: Joi.any(),
  gisBack: Joi.any(),
  gisSignature: Joi.any(),

  secretarysCert: Joi.any(),
  secretarysCertBack: Joi.any(),
  secretarysCertSignature: Joi.any(),

  // bldgNameNo: Joi.any(),
});
